// extracted by mini-css-extract-plugin
module.exports = {"load-more":"styles__load-more___2SObS"};